// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'c7f75dbd';
